// extracted by mini-css-extract-plugin
export var smallSpinner = "_xd-0";